<template>
  <footer class="site_footer">
    <div class="container">
      <div class="footer_area row justify-content-between">
        <div class="search_area">
          <!-- <input
            type="text"
            class="search_input"
            placeholder="search ..."
          >
          <button
            type="submit"
            class="search_button"
          >
            <i class="fa fa-search" />
          </button> -->
          <div class="gcse-searchbox-only" />
        </div>
        <div class="visitors_area text-right">
          瀏覽人數：{{ uniqueVisitorCountGetter }}
        </div>
      </div>
      <div class="copyright_area">
        <p>國立臺灣科技大學 版權所有 © copyright 2019 All Rights Reserved</p>
        <p>地址：台北市 106大安區基隆路四段43號 TEL：02-27333141#5124 E-Mail：career@mail.ntust.edu.tw</p>
        <p>本網站由 國立臺灣科技大學 設計製作 本網站所有圖文均受法律保護</p>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Footer',
  computed: {
    ...mapGetters('layouts', [
      'uniqueVisitorCountGetter'
    ])
  },
  created () {
    if (Number(this.uniqueVisitorCountGetter) < 1) {
      this.getUniqueVisitorCount()
    }
  },
  methods: {
    ...mapActions('layouts', [
      'getUniqueVisitorCount'
    ])
  }
}
</script>
<style>
.gsc-search-button {
  display: none;
}
</style>
